import {FC, useState} from 'react'
import {bookingFlows} from "../../constants/global";
import {Link} from "react-router-dom";
import {getNextStep, getPrevStep, isStepFulfilled} from "../../lib/booking";

interface Props {
    item:any,
    index:number,
    booking:Booking,
    setBooking:Function
}

const Item: FC<Props> = ({item, index, booking, setBooking}) => {
    const bookingFlow = bookingFlows[booking.booking_flow]
    const activeStep = item.content_type
    const prev = getPrevStep(bookingFlow.menu, activeStep)
    let stepFullFilled = isStepFulfilled(prev, booking)
    let currentStepIndex = bookingFlows[booking.booking_flow].menu.indexOf(bookingFlows[booking.booking_flow].step)+2;
    let currentStepFullFilled = isStepFulfilled(bookingFlows[booking.booking_flow].step, booking)

    if(!prev) {
        stepFullFilled = true
    }

    if(stepFullFilled && index < currentStepIndex+1) {
        if (item.content_type === bookingFlows[booking.booking_flow].step || (currentStepFullFilled && currentStepIndex === index)) {
            return <li className={"current-menu-item"}>
                <Link to={'/' + item.slug}>
                    <span>{index}</span>
                    <div className={"title"}>{item.title}</div>
                </Link>
            </li>
        } else {
            return <li className={"complete"}>
                <Link to={'/' + item.slug}>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                            <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                        </svg>
                    </span>
                    <div className={"title"}>{item.title}</div>
                </Link>
            </li>
        }
    }

    return <li className={'disabled'}><Link to={'#'}><span>{index}</span><div className={"title"}>{item.title}</div></Link></li>
};

export default Item
